import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-country-flag',
  host: { class: 'inline-flex shrink-0' },
  template: `
    <svg
      viewBox="0 0 16 12"
      [attr.width]="size"
      [attr.height]="size * 0.75"
      role="img"
      [attr.aria-label]="label || null"
      [attr.aria-hidden]="label ? null : true"
      class="rounded-[2px] ring-1 ring-inset ring-aav-scrim/10"
    >
      <ng-container [ngSwitch]="code">
        <g *ngSwitchCase="'BR'">
          <rect width="16" height="12" fill="#009B3A" />
          <path d="M8 1.4 14.6 6 8 10.6 1.4 6Z" fill="#FEDF00" />
          <circle cx="8" cy="6" r="2.5" fill="#002776" />
        </g>

        <g *ngSwitchCase="'PT'">
          <rect width="16" height="12" fill="#DA291C" />
          <rect width="6.4" height="12" fill="#006233" />
          <circle cx="6.4" cy="6" r="2.3" fill="#FFE900" />
          <circle cx="6.4" cy="6" r="1.4" fill="#DA291C" />
        </g>

        <g *ngSwitchCase="'ES'">
          <rect width="16" height="12" fill="#AA151B" />
          <rect y="3" width="16" height="6" fill="#F1BF00" />
        </g>

        <rect *ngSwitchDefault width="16" height="12" fill="#D4D4D4" />
      </ng-container>
    </svg>
  `,
})
export class CountryFlagComponent {
  @Input() code = '';
  @Input() size = 16;
  @Input() label = '';
}
